import { render } from "./AttributesDropdown.vue?vue&type=template&id=48c05886"
import script from "./AttributesDropdown.vue?vue&type=script&lang=js"
export * from "./AttributesDropdown.vue?vue&type=script&lang=js"

import "./AttributesDropdown.vue?vue&type=style&index=0&id=48c05886&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__